import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';
import styled from 'styled-components';

export const ConfirmButton = styled(Button)({
  padding: '0 1.2rem',
});

const styles = {
  tableRow: {
    position: 'relative',
    borderBottom: `1px solid ${colors.neutral[300]}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    letterSpacing: '0.02rem',
    padding: '1.6rem 0rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
      paddingRight: '1rem',
    },
    '&:nth-child(3)': {
      paddingRight: '1rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  textProposalStatus: {
    padding: 0,
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
    },
  },
  cellAlignWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  expiredLabel: {
    margin: 0,
    color: colors.red[600],
    font: {
      size: '1.2rem',
      lineHeight: '2rem',
      weight: 500,
    },
    textTransform: 'uppercase',
  },
  preferredProposal: {
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      width: '0.8rem',
      height: '100%',
      backgroundColor: colors.purple[300],
    },
  },
  carrierLogo: {
    height: '2.4rem',
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  expiredStatusTag: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.8rem',
    color: colors.red[600],
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
